import { SetLiveQueueType } from "../action-types/livequeue.action.types";
import { LiveQueue } from "../actions/livequeue.action";

interface LiveQueueState {
  liveQueueMessage: any;
}

const initialState = {
  liveQueueMessage: {},
};

const LiveQueueReducer = (
  state: LiveQueueState = initialState,
  action: LiveQueue
): LiveQueueState => {
  switch (action.type) {
    case SetLiveQueueType.SET_LIVE_QUEUE:
      return {
        ...state,
        liveQueueMessage: action.payload,
      };
    default:
      return state;
  }
};

export default LiveQueueReducer;
